import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const ChevronIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 8, height = 14, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M7 1L1 7L7 13"
          stroke="#1677FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
